import React from "react";
import { WrapStyle, FieldLabel, FieldBody } from "./styles";

export interface CreateDocumentFormFieldProps
  extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  labelStyle?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  vertical?: boolean;
}

const CreateDocumentFormField = ({
  label,
  vertical,
  children,
  labelStyle,
  bodyStyle,
  ...rest
}: CreateDocumentFormFieldProps) => {
  return (
    <WrapStyle {...rest} vertical={vertical}>
      <FieldLabel style={labelStyle}>{label}</FieldLabel>
      <FieldBody style={bodyStyle}>{children}</FieldBody>
    </WrapStyle>
  );
};

export default CreateDocumentFormField;
